import React from 'react';
import { connect } from 'react-redux';
import ControlItem from '../components/controller/modules';
import { mapStateToProps, mapDispatchToProps } from '../containers/controller/controller';
import V2Choice from './V2Choice';
import V2Text from './V2Text';

// Answer panel. The common types get v2 components; rarer ones (dropdown, slide, quiz,
// buttons_free) reuse the v1 modules inside a light card so they keep working.
function V2Answers(props) {
  const { current } = props;
  if (!current) return null;
  if (current.type === 'buttons') return <V2Choice key={current.id} {...props} />;
  if (current.type === 'multi') return <V2Choice key={current.id} multi {...props} />;
  if (current.type === 'text') return <V2Text key={current.id} {...props} />;
  return (
    <div className="v2-legacy">
      <ControlItem {...props} />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(V2Answers);
